<template>
  <v-card :class="`${backgroundColor} elevation-0`">
    <v-card-text>
      <v-col>
        <v-row>
          <v-col>
            <span class="subtitle-1 font-weight-bold white--text">Welcome to iAdOps 5</span>
          </v-col>
        </v-row>

        <v-row class="caption font-weight-medium white--text mt-0">
          <v-col>
            <p>
              This release introduces Saved Reports, Bookmarks, Network Settings and more. To learn more about these features, please visit our <router-link
                to="/docs"
                class="white--text font-weight-bold"
              >
                documentation
              </router-link>.
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('auth')

export default {
  name: 'ReleaseCard',
  computed: {
    ...mapGetters(['inDarkMode']),
    backgroundColor() {
      return this.inDarkMode ? 'blueblack' : 'darkblue'
    },
  },
}
</script>
